import { useMemo, useState } from "react";
import { Plus } from "lucide-react";
import { Shimmer } from "../Shimmer/Shimmer";
import { LimitsEnrichItemTable } from "../LimitsEnrichItemTable/LimitsEnrichItemTable";
import { LimitsEnrichItemModal } from "../LimitsEnrichItemModal/LimitsEnrichItemModal";
import { useLimitsEnrichItemList } from "../../hooks/useLimitsEnrichItemList";
import type { LimitsEnrichItem } from "../../api/limitsEnrichItem";
import "../RequestsSection/RequestsSection.scss";

export const LimitsEnrichItemSection = () => {
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { data, loading, error, refetch, applySaved } = useLimitsEnrichItemList();

  const selectedItem = useMemo(
    () => data.find((item) => item.id === selectedId) ?? null,
    [data, selectedId]
  );

  const handleSaved = (item: LimitsEnrichItem) => {
    applySaved(item);
    setCreateOpen(false);
    setSelectedId(null);
    refetch();
  };

  return (
    <section className="requests-section requests-section--embedded" aria-label="Докупка проверок">
      <div className="requests-section-header">
        <h1 className="requests-section-title">Докупка проверок</h1>
        <button
          type="button"
          className="requests-section-create-btn"
          onClick={() => setCreateOpen(true)}
        >
          <Plus size={20} />
          <span>Создать пакет</span>
        </button>
      </div>

      {loading ? (
        <Shimmer rows={5} />
      ) : error ? (
        <div className="requests-section-error">
          <p className="requests-section-error__text">{error}</p>
          <button type="button" className="requests-section-error__retry" onClick={refetch}>
            Повторить
          </button>
        </div>
      ) : (
        <LimitsEnrichItemTable data={data} onRowClick={setSelectedId} />
      )}

      {createOpen && (
        <LimitsEnrichItemModal onClose={() => setCreateOpen(false)} onSaved={handleSaved} />
      )}

      {selectedItem && (
        <LimitsEnrichItemModal
          item={selectedItem}
          onClose={() => setSelectedId(null)}
          onSaved={handleSaved}
        />
      )}
    </section>
  );
};
